// eslint-disable-next-line import/prefer-default-export
export const storeCodes = [
  '6200 - TELUS Granville',
  '6400 - TELUS Devonshire Mall',
  '6401 - TELUS Fairview Park Mall',
  '6402 - TELUS Lime Ridge SC',
  '6403 - TELUS Fairview Mall',
  '6405 - TELUS Markville SC',
  '6406 - TELUS Toronto Eaton Centre',
  '6407 - TELUS Erin Mills Town Centre',
  '6408 - TELUS Carrefour Laval',
  '6409 - TELUS Georgian Mall',
  '6410 - TELUS Eastgate Square',
  '6411 - TELUS Champlain Place',
  '6412 - TELUS Regent Mall',
  '6413 - TELUS Bayshore Shopping Centre',
  '6414 - TELUS Lansdowne Place',
  '6415 - TELUS Mic Mac Mall',
  '6416 - TELUS Masonville Place',
  '6417 - TELUS Pickering Town Centre',
  '6418 - TELUS Pen Centre',
  '6420 - TELUS Cataraqui Town Centre',
  '6421 - TELUS Scarborough Town Centre',
  '6423 - TELUS Oshawa Centre',
  '6424 - TELUS Square One',
  '6425 - TELUS Hillcrest Mall',
  '6426 - TELUS Dufferin Mall',
  '6427 - TELUS Yorkdale Shopping Centre',
  '6428 - TELUS Upper Canada Mall',
  "6429 - TELUS Place D'Orleans",
  '6430 - TELUS White Oaks Mall',
  '6431 - TELUS Stone Road Mall',
  '6432 - TELUS Burlington Mall',
  '6433 - TELUS Tecumseh Mall',
  '6434 - TELUS Lynden Park Mall',
  '6435 - TELUS Carlingwood SC',
  '6438 - TELUS Les Prom. St. Bruno',
  "6439 - TELUS Les Gal. D'Anjou",
  '6441 - TELUS Fairview Pointe Claire',
  '6443 - TELUS Centre Rockland',
  '6444 - TELUS Carrefour Angrignon',
  '6445 - TELUS Place Rosemere',
  '6446 - TELUS Place Versailles',
  '6447 - TELUS Susie Lake',
  '6449 - TELUS Halifax Shopping Centre',
  '6450 - TELUS Place Vertu',
  '6451 - TELUS Montreal Eaton Centre',
  '6452 - TELUS Place Fleur de Lys',
  '6453 - TELUS St. Vital Centre',
  '6458 - TELUS Montreal Flagship',
  '6459 - TELUS Place Ste Foy',
  '6461 - TELUS Les Rivieres',
  '6462 - TELUS Les Gal. de Hull',
  '6463 - TELUS St. Laurent Centre',
  '6464 - TELUS New Sudbury Centre',
  '6466 - TELUS Quinte Mall',
  '6467 - TELUS Conestoga Mall',
  '6468 - TELUS McAllister Place',
  '6469 - TELUS Village Shopping Centre',
  '6470 - TELUS Cornwall Square',
  '6471 - TELUS Yonge Eglinton Ctr',
  '6472 - TELUS Rideau Shopping Centre',
  '6473 - TELUS Trois Rivieres Ouest',
  '6477 - TELUS Oakville Place',
  '6478 - TELUS Les Gal. de Terrebonne',
  '6479 - TELUS First Maple Ctr Chatham',
  '6480 - TELUS Mayflower Mall',
  '6481 - TELUS Avalon Mall',
  '6482 - TELUS Les Gal. Rive Nord',
  '6483 - TELUS Carrefour du Nord',
  '6485 - TELUS 4202 St. Denis',
  '6486 - TELUS Heritage Place',
  '6487 - TELUS Cornwall Centre',
  '6488 - TELUS Midtown Plaza',
  '6490 - TELUS Les Prom. Gatineau',
  '6492 - TELUS Corner Brook Plaza',
  '6493 - TELUS Mapleview SC',
  '6496 - TELUS Westside Market Village',
  '6498 - TELUS Place du Royaume',
  '6500 - TELUS First Railside',
  '6501 - TELUS 477 Dundas',
  '6502 - TELUS Centre Alma',
  '6503 - TELUS Kanata Centrum Walk',
  '6504 - TELUS Huntsville Power Centre',
  '6507 - TELUS Sherway Gardens',
  '6508 - TELUS Brock/Taunton Power Ctr',
  '6509 - TELUS Vaughan Mills',
  '6512 - TELUS Main Street Listowel',
  '6513 - TELUS Festival Marketplace',
  '6514 - TELUS Tillsonburg Town Centre',
  '6519 - TELUS Aurora Gateway',
  '6520 - TELUS Southland SC',
  '6521 - TELUS Les Gal. de la Capitale',
  '6523 - TELUS Milton Crossroads',
  '6525 - TELUS Westridge Orillia',
  '6529 - TELUS Alliston Market Village',
  '6530 - TELUS La Plaza de la Mauricie',
  '6533 - TELUS Polo Park Inline',
  '6535 - TELUS Northgate SC',
  '6541 - TELUS Place Laurier',
  "6550 - TELUS Carrefour de L'Estrie",
  '6551 - TELUS Niagara Square',
  '6557 - TELUS RioCan Durham',
  '6559 - TELUS Taunton/Harmony',
  '6562 - TELUS Chapman Mills',
  '6564 - TELUS Lambton Mall',
  '6565 - TELUS 10/30 Lifestyle Centre',
  '6569 - TELUS Heartland Town Centre',
  '6573 - TELUS Bracebridge',
  '6575 - TELUS Bridgeview Plaza',
  '6577 - TELUS Eglinton Square',
  '6580 - TELUS Wheeler Park Power Ctr',
  '6582 - TELUS Carrefour Argenteuil',
  '6586 - TELUS West Bowmanville SC',
  '6587 - TELUS Bramalea City Centre',
  '6591 - TELUS Dartmouth Crossing',
  '6592 - TELUS Cambridge Centre',
  '6593 - TELUS Timmins Square',
  '6595 - TELUS Carleton Place Colonnade',
  '6601 - TELUS Northgate Mall (SK)',
  '6602 - TELUS Centre at Circle & 8th',
  '6603 - TELUS Station Mall',
  '6604 - TELUS Lawson Heights',
  '6605 - TELUS Prince Albert',
  '6607 - TELUS Seaway Mall',
  '6609 - TELUS Willowbrook Mall',
  '6610 - TELUS Bonnie Doon SC',
  '6612 - TELUS Central City',
  '6613 - TELUS Country Hills Town Ctr',
  '6614 - TELUS Cross Iron Mills',
  '6615 - TELUS Edmonton City Centre',
  '6617 - TELUS Kingsway Mall',
  '6618 - TELUS Londonderry Mall',
  '6619 - TELUS Mill Woods Town Centre',
  '6620 - TELUS North Hill Centre',
  '6621 - TELUS Northgate Centre (AB)',
  '6622 - TELUS Royal City Centre',
  '6623 - TELUS Southgate Centre',
  '6624 - TELUS St. Albert Centre',
  '6625 - TELUS Sunridge Mall',
  '6630 - TELUS Uptown',
  '6631 - TELUS Southcentre Mall',
  '6634 - TELUS Chinook Centre Flagship',
  '6635 - TELUS Chinook Centre Main',
  '6636 - TELUS Cottonwood Mall',
  '6638 - TELUS Crystal Mall',
  '6639 - TELUS Guildford Town Centre',
  '6640 - TELUS Hillside Centre',
  '6641 - TELUS Lougheed Town Centre',
  '6642 - TELUS Market Mall',
  '6644 - TELUS Mayfair Shopping Centre',
  '6645 - TELUS Metropolis at Metrotown',
  '6648 - TELUS Woodgrove Centre',
  '6650 - TELUS Westshore Town Centre',
  '6651 - TELUS West Edmonton Mall Main',
  '6652 - TELUS West Edmonton Mall',
  '6653 - TELUS Tillicum Mall',
  '6654 - TELUS Pacific Centre',
  '6655 - TELUS Park Royal SC',
  '6656 - TELUS Richmond Centre',
  '6657 - TELUS Scottsdale Centre',
  '6658 - TELUS Semiahmoo SC',
  '6659 - TELUS Seven Oaks',
  '6660 - TELUS Shawnessy SC',
  '6661 - TELUS Shepard Regional Centre',
  '6664 - TELUS The Bay Centre',
  '6665 - TELUS The Core',
  '6666 - TELUS Coquitlam Centre',
  '6667 - TELUS Kitsilano',
  '6668 - TELUS Lloyd Mall',
  '6669 - TELUS Lynn Valley',
  '6670 - TELUS Westhills',
  '6671 - TELUS Whistler',
  '6673 - TELUS Peter Pond SC',
  '6674 - TELUS Pine Centre',
  '6676 - TELUS Orchard Park SC',
  '6678 - TELUS Intercity SC',
  '6679 - TELUS Collingwood',
  '6680 - TELUS Garden',
  '6681 - TELUS Deerfoot Meadows',
  '6682 - TELUS Beacon Hill',
  '6683 - TELUS Marlborough Mall',
  '6684 - TELUS 34th Avenue',
  '6686 - TELUS Lindsay Square',
  '6687 - TELUS Robson Street',
  '6688 - TELUS Carrefour Richelieu',
  '6689 - TELUS Les Gal. de Granby',
  '6690 - TELUS Les Gal. St. Hyacinthe',
  '6691 - TELUS Les Prom. Drummondville',
  '6693 - TELUS Capilano Mall',
  '6701 - TELUS Trinity Common',
  '6702 - TELUS Tsawwassen Mills',
  '6707 - TELUS The Path',
  '6717 - TELUS Polo Park Kiosk',
  '6721 - TELUS Portage Place',
  '6722 - TELUS Park Place (ON)',
  '6723 - TELUS Park Place SC',
  '6724 - TELUS The Boardwalk',
  '6727 - TELUS - Metropolis Flagship',
  '6731 - TELUS Les Galeries Lac St Jean',
  '6801 - KOODO Metropolis at Metrotown',
  '6803 - KOODO Guildford Town Centre',
  '6804 - KOODO Richmond Centre',
  '6806 - KOODO Toronto Eaton Centre',
  '6807 - KOODO Scarborough Town Centre',
  '6808 - KOODO Square One',
  '6812 - KOODO Lime Ridge SC',
  '6815 - KOODO Carrefour Laval',
  '6816 - KOODO Les Prom. St. Bruno',
  '6817 - KOODO Fairview Pointe Claire',
  '6818 - KOODO Montreal Eaton Centre',
  '6819 - KOODO Carrefour Angrignon',
  "6820 - KOODO Les Gal. D'Anjou",
  '6821 - KOODO Carrefour du Nord',
  '6822 - KOODO Mail Champlain',
  '6825 - KOODO Oshawa Centre',
  '6826 - KOODO Yorkdale Shopping Centre',
  '6831 - KOODO Bramalea City Centre',
  '6835 - KOODO Cataraqui Town Centre',
  '6836 - KOODO Devonshire Mall',
  '6839 - KOODO Kingsway Mall',
  '6840 - KOODO Les Gal. de la Capitale',
  '6841 - KOODO Londonderry Mall',
  '6842 - KOODO Market Mall',
  '6844 - KOODO Masonville Place',
  '6846 - KOODO Southcentre Mall',
  '6848 - KOODO Stone Road Mall',
  '6850 - KOODO Pen Centre',
  '6851 - KOODO Place Laurier',
  '6852 - KOODO Sunridge Mall',
  '6858 - KOODO Burlington Mall',
  '6860 - KOODO St. Laurent Centre',
  '6861 - KOODO Lynden Park Mall',
  '6862 - KOODO Halifax Shopping Centre',
  '6863 - KOODO Avalon Mall',
  '6864 - KOODO Regent Mall',
  '6865 - KOODO McAllister Place',
  '6866 - KOODO Champlain Place',
  '6870 - KOODO Quinte Mall',
  '6871 - KOODO Les Rivieres',
  '6872 - KOODO Place du Royaume',
  '6873 - KOODO Place Longueuil',
  '6874 - KOODO La Grande Place des B-F',
  '6877 - KOODO White Oaks Mall',
  '6878 - KOODO Markville SC',
  '6880 - KOODO Lansdowne Place',
  '6882 - KOODO Orchard Park SC',
  '6883 - KOODO Northgate SC',
  "6887 - KOODO Carrefour de L'Estrie",
  '6891 - KOODO Park Place SC',
  '6892 - KOODO Sunnyside Mall',
  '6896 - KOODO Les Gal. de Granby',
  '6898 - KOODO Mic Mac Mall',
  '6900 - KOODO Les Prom. Gatineau',
  '6902 - KOODO Les Gal. Chagnon',
  '6903 - KOODO Cross Iron Mills',
  '6908 - KOODO New Sudbury Centre',
  '6911 - KOODO Les Gal. Joliette',
  '6914 - KOODO Station Mall',
  '6917 - KOODO Place Versailles',
  '6918 - KOODO Lambton Mall',
  '6919 - KOODO Chinook Centre',
  '6921 - KOODO Bowmanville Mall',
  '6924 - KOODO Polo Park SC',
  '6928 - KOODO Southgate Centre',
  '6929 - KOODO Les Prom. Beauport',
  '6931 - KOODO Les Prom. Drummondville',
  '6932 - KOODO Les Gal. St. Hyacinthe',
  '6939 - KOODO Bayshore Shopping Centre',
  '6945 - KOODO Corner Brook Plaza',
  '6952 - KOODO Woodgrove Centre',
  '6953 - KOODO West Edmonton Mall',
  '6955 - KOODO Cottonwood Mall',
  '6956 - KOODO Portage Place',
  '6962 - KOODO The Bay Centre',
  '6966 - KOODO Pacific Centre',
  '6967 - KOODO Willowbrook Mall'
];

export const storeCodeOutletMapping = {
  '6200 - TELUS Granville': '1100045134',
  '6400 - TELUS Devonshire Mall': '1100030071',
  '6401 - TELUS Fairview Park Mall': '1100030076',
  '6402 - TELUS Lime Ridge SC': '1100030081',
  '6403 - TELUS Fairview Mall': '1100030075',
  '6405 - TELUS Markville SC': '1100030083',
  '6406 - TELUS Toronto Eaton Centre': '1100030104',
  '6407 - TELUS Erin Mills Town Centre': '1100030074',
  '6408 - TELUS Carrefour Laval': '1100030041',
  '6409 - TELUS Georgian Mall': '1100030077',
  '6410 - TELUS Eastgate Square': '1100030073',
  '6411 - TELUS Champlain Place': '1100030068',
  '6412 - TELUS Regent Mall': '1100030096',
  '6413 - TELUS Bayshore Shopping Centre': '1100030064',
  '6414 - TELUS Lansdowne Place': '1100030080',
  '6415 - TELUS Mic Mac Mall': '1100030086',
  '6416 - TELUS Masonville Place': '1100030084',
  '6417 - TELUS Pickering Town Centre': '1100030092',
  '6418 - TELUS Pen Centre': '1100030091',
  '6420 - TELUS Cataraqui Town Centre': '1100030067',
  '6421 - TELUS Scarborough Town Centre': '1100028901',
  '6423 - TELUS Oshawa Centre': '1100030090',
  '6424 - TELUS Square One': '1100030098',
  '6425 - TELUS Hillcrest Mall': '1100030079',
  '6426 - TELUS Dufferin Mall': '1100030072',
  '6427 - TELUS Yorkdale Shopping Centre': '1100030109',
  '6428 - TELUS Upper Canada Mall': '1100030106',
  "6429 - TELUS Place D'Orleans": '1100030093',
  '6430 - TELUS White Oaks Mall': '1100030107',
  '6431 - TELUS Stone Road Mall': '1100030101',
  '6432 - TELUS Burlington Mall': '1100030065',
  '6433 - TELUS Tecumseh Mall': '1100030102',
  '6434 - TELUS Lynden Park Mall': '1100030082',
  '6435 - TELUS Carlingwood SC': '1100030066',
  '6438 - TELUS Les Prom. St. Bruno': '1100030049',
  "6439 - TELUS Les Gal. D'Anjou": '1100030046',
  '6441 - TELUS Fairview Pointe Claire': '1100030056',
  '6443 - TELUS Centre Rockland': '1100029402',
  '6444 - TELUS Carrefour Angrignon': '1100030043',
  '6445 - TELUS Place Rosemere': '1100030059',
  '6446 - TELUS Place Versailles': '1100030060',
  '6447 - TELUS Susie Lake': '1100030063',
  '6449 - TELUS Halifax Shopping Centre': '1100030078',
  '6450 - TELUS Place Vertu': '1100030052',
  '6451 - TELUS Montreal Eaton Centre': '1100030087',
  '6452 - TELUS Place Fleur de Lys': '1100030050',
  '6453 - TELUS St. Vital Centre': '1100030100',
  '6458 - TELUS Montreal Flagship': '1100029401',
  '6459 - TELUS Place Ste Foy': '1100030051',
  '6461 - TELUS Les Rivieres': '1100030044',
  '6462 - TELUS Les Gal. de Hull': '1100030047',
  '6463 - TELUS St. Laurent Centre': '1100030099',
  '6464 - TELUS New Sudbury Centre': '1100030088',
  '6466 - TELUS Quinte Mall': '1100030095',
  '6467 - TELUS Conestoga Mall': '1100030069',
  '6468 - TELUS McAllister Place': '1100030085',
  '6469 - TELUS Village Shopping Centre': '1100030105',
  '6470 - TELUS Cornwall Square': '1100030070',
  '6471 - TELUS Yonge Eglinton Ctr': '1100030062',
  '6472 - TELUS Rideau Shopping Centre': '1100032501',
  '6473 - TELUS Trois Rivieres Ouest': '1100034552',
  '6477 - TELUS Oakville Place': '1100030089',
  '6478 - TELUS Les Gal. de Terrebonne': '1100030042',
  '6479 - TELUS First Maple Ctr Chatham': '1100030111',
  '6480 - TELUS Mayflower Mall': '1100030322',
  '6481 - TELUS Avalon Mall': '1100030324',
  '6482 - TELUS Les Gal. Rive Nord': '1100030281',
  '6483 - TELUS Carrefour du Nord': '1100030323',
  '6485 - TELUS 4202 St. Denis': '1100030327',
  '6486 - TELUS Heritage Place': '1100030329',
  '6487 - TELUS Cornwall Centre': '1100030326',
  '6488 - TELUS Midtown Plaza': '1100030328',
  '6490 - TELUS Les Prom. Gatineau': '1100030443',
  '6492 - TELUS Corner Brook Plaza': '1100030445',
  '6493 - TELUS Mapleview SC': '1100030446',
  '6496 - TELUS Westside Market Village': '1100031141',
  '6498 - TELUS Place du Royaume': '1100031143',
  '6500 - TELUS First Railside': '1100030661',
  '6501 - TELUS 477 Dundas': '1100031144',
  '6502 - TELUS Centre Alma': '1100031542',
  '6503 - TELUS Kanata Centrum Walk': '1100030325',
  '6504 - TELUS Huntsville Power Centre': '1100032401',
  '6507 - TELUS Sherway Gardens': '1100032741',
  '6508 - TELUS Brock/Taunton Power Ctr': '1100032822',
  '6509 - TELUS Vaughan Mills': '1100032821',
  '6512 - TELUS Main Street Listowel': '1100033163',
  '6513 - TELUS Festival Marketplace': '1100033164',
  '6514 - TELUS Tillsonburg Town Centre': '1100033165',
  '6519 - TELUS Aurora Gateway': '1100033944',
  '6520 - TELUS Southland SC': '1100033981',
  '6521 - TELUS Les Gal. de la Capitale': '1100033982',
  '6523 - TELUS Milton Crossroads': '1100033984',
  '6525 - TELUS Westridge Orillia': '1100033986',
  '6529 - TELUS Alliston Market Village': '1100033990',
  '6530 - TELUS La Plaza de la Mauricie': '1100034064',
  '6533 - TELUS Polo Park Inline': '1100034146',
  '6535 - TELUS Northgate SC': '1100034164',
  '6541 - TELUS Place Laurier': '1100034366',
  "6550 - TELUS Carrefour de L'Estrie": '1100034492',
  '6551 - TELUS Niagara Square': '1100034491',
  '6557 - TELUS RioCan Durham': '1100034613',
  '6559 - TELUS Taunton/Harmony': '1100034631',
  '6562 - TELUS Chapman Mills': '1100034994',
  '6564 - TELUS Lambton Mall': '1100035015',
  '6565 - TELUS 10/30 Lifestyle Centre': '1100035016',
  '6569 - TELUS Heartland Town Centre': '1100036037',
  '6573 - TELUS Bracebridge': '1100036200',
  '6575 - TELUS Bridgeview Plaza': '1100036202',
  '6577 - TELUS Eglinton Square': '1100036438',
  '6580 - TELUS Wheeler Park Power Ctr': '1100037297',
  '6582 - TELUS Carrefour Argenteuil': '1100037299',
  '6586 - TELUS West Bowmanville SC': '1100037680',
  '6587 - TELUS Bramalea City Centre': '1100037681',
  '6591 - TELUS Dartmouth Crossing': '1100038564',
  '6592 - TELUS Cambridge Centre': '1100040257',
  '6593 - TELUS Timmins Square': '1100040554',
  '6595 - TELUS Carleton Place Colonnade': '1100040691',
  '6601 - TELUS Northgate Mall (SK)': '1100041507',
  '6602 - TELUS Centre at Circle & 8th': '1100041574',
  '6603 - TELUS Station Mall': '1100041575',
  '6604 - TELUS Lawson Heights': '1100041814',
  '6605 - TELUS Prince Albert': '1100041919',
  '6607 - TELUS Seaway Mall': '1100042743',
  '6609 - TELUS Willowbrook Mall': '1100043020',
  '6610 - TELUS Bonnie Doon SC': '1100043018',
  '6612 - TELUS Central City': '1100043016',
  '6613 - TELUS Country Hills Town Ctr': '1100043019',
  '6614 - TELUS Cross Iron Mills': '1100043036',
  '6615 - TELUS Edmonton City Centre': '1100043042',
  '6617 - TELUS Kingsway Mall': '1100043017',
  '6618 - TELUS Londonderry Mall': '1100043040',
  '6619 - TELUS Mill Woods Town Centre': '1100043045',
  '6620 - TELUS North Hill Centre': '1100043034',
  '6621 - TELUS Northgate Centre (AB)': '1100043038',
  '6622 - TELUS Royal City Centre': '1100043015',
  '6623 - TELUS Southgate Centre': '1100043037',
  '6624 - TELUS St. Albert Centre': '1100043039',
  '6625 - TELUS Sunridge Mall': '1100043035',
  '6630 - TELUS Uptown': '1100043903',
  '6631 - TELUS Southcentre Mall': '1100043902',
  '6634 - TELUS Chinook Centre Flagship': '1100043862',
  '6635 - TELUS Chinook Centre Main': '1100043864',
  '6636 - TELUS Cottonwood Mall': '1100043898',
  '6638 - TELUS Crystal Mall': '1100043867',
  '6639 - TELUS Guildford Town Centre': '1100043901',
  '6640 - TELUS Hillside Centre': '1100043857',
  '6641 - TELUS Lougheed Town Centre': '1100043871',
  '6642 - TELUS Market Mall': '1100043866',
  '6644 - TELUS Mayfair Shopping Centre': '1100043886',
  '6645 - TELUS Metropolis at Metrotown': '1100043858',
  '6648 - TELUS Woodgrove Centre': '1100043891',
  '6650 - TELUS Westshore Town Centre': '1100043893',
  '6651 - TELUS West Edmonton Mall Main': '1100043884',
  '6652 - TELUS West Edmonton Mall': '1100043888',
  '6653 - TELUS Tillicum Mall': '1100043889',
  '6654 - TELUS Pacific Centre': '1100043865',
  '6655 - TELUS Park Royal SC': '1100043881',
  '6656 - TELUS Richmond Centre': '1100043894',
  '6657 - TELUS Scottsdale Centre': '1100043896',
  '6658 - TELUS Semiahmoo SC': '1100043899',
  '6659 - TELUS Seven Oaks': '1100043897',
  '6660 - TELUS Shawnessy SC': '1100043872',
  '6661 - TELUS Shepard Regional Centre': '1100043876',
  '6664 - TELUS The Bay Centre': '1100043887',
  '6665 - TELUS The Core': '1100043880',
  '6666 - TELUS Coquitlam Centre': '1100043906',
  '6667 - TELUS Kitsilano': '1100043905',
  '6668 - TELUS Lloyd Mall': '1100043892',
  '6669 - TELUS Lynn Valley': '1100043879',
  '6670 - TELUS Westhills': '1100043882',
  '6671 - TELUS Whistler': '1100043900',
  '6673 - TELUS Peter Pond SC': '1100044246',
  '6674 - TELUS Pine Centre': '1100044247',
  '6676 - TELUS Orchard Park SC': '1100045159',
  '6678 - TELUS Intercity SC': '1100045237',
  '6679 - TELUS Collingwood': '1100045496',
  '6680 - TELUS Garden': '1100045505',
  '6681 - TELUS Deerfoot Meadows': '1100045506',
  '6682 - TELUS Beacon Hill': '1100045507',
  '6683 - TELUS Marlborough Mall': '1100045508',
  '6684 - TELUS 34th Avenue': '1100045703',
  '6686 - TELUS Lindsay Square': '1100046410',
  '6687 - TELUS Robson Street': '1100046427',
  '6688 - TELUS Carrefour Richelieu': '1100045429',
  '6689 - TELUS Les Gal. de Granby': '1100045430',
  '6690 - TELUS Les Gal. St. Hyacinthe': '1100045431',
  '6691 - TELUS Les Prom. Drummondville': '1100045432',
  '6693 - TELUS Capilano Mall': '1100045345',
  '6701 - TELUS Trinity Common': '1100047997',
  '6702 - TELUS Tsawwassen Mills': '1100048255',
  '6707 - TELUS The Path': '1100048813',
  '6717 - TELUS Polo Park Kiosk': '1100048484',
  '6721 - TELUS Portage Place': '1100048488',
  '6722 - TELUS Park Place (ON)': '1100048819',
  '6723 - TELUS Park Place SC': '1100048741',
  '6724 - TELUS The Boardwalk': '1100048816',
  '6727 - TELUS - Metropolis Flagship': '1100050723',
  '6731 - TELUS Les Galeries Lac St Jean': '1100052655',
  '6801 - KOODO Metropolis at Metrotown': '1100038337',
  '6803 - KOODO Guildford Town Centre': '1100038339',
  '6804 - KOODO Richmond Centre': '1100038340',
  '6806 - KOODO Toronto Eaton Centre': '1100038377',
  '6807 - KOODO Scarborough Town Centre': '1100038378',
  '6808 - KOODO Square One': '1100038379',
  '6812 - KOODO Lime Ridge SC': '1100038381',
  '6815 - KOODO Carrefour Laval': '1100038400',
  '6816 - KOODO Les Prom. St. Bruno': '1100038401',
  '6817 - KOODO Fairview Pointe Claire': '1100038417',
  '6818 - KOODO Montreal Eaton Centre': '1100038424',
  '6819 - KOODO Carrefour Angrignon': '1100038418',
  "6820 - KOODO Les Gal. D'Anjou": '1100038419',
  '6821 - KOODO Carrefour du Nord': '1100038421',
  '6822 - KOODO Mail Champlain': '1100038420',
  '6825 - KOODO Oshawa Centre': '1100038498',
  '6826 - KOODO Yorkdale Shopping Centre': '1100038577',
  '6831 - KOODO Bramalea City Centre': '1100040409',
  '6835 - KOODO Cataraqui Town Centre': '1100040408',
  '6836 - KOODO Devonshire Mall': '1100040462',
  '6839 - KOODO Kingsway Mall': '1100040470',
  '6840 - KOODO Les Gal. de la Capitale': '1100040391',
  '6841 - KOODO Londonderry Mall': '1100040469',
  '6842 - KOODO Market Mall': '1100040471',
  '6844 - KOODO Masonville Place': '1100040466',
  '6846 - KOODO Southcentre Mall': '1100040472',
  '6848 - KOODO Stone Road Mall': '1100040459',
  '6850 - KOODO Pen Centre': '1100040460',
  '6851 - KOODO Place Laurier': '1100040392',
  '6852 - KOODO Sunridge Mall': '1100040474',
  '6858 - KOODO Burlington Mall': '1100040587',
  '6860 - KOODO St. Laurent Centre': '1100040680',
  '6861 - KOODO Lynden Park Mall': '1100040683',
  '6862 - KOODO Halifax Shopping Centre': '1100040685',
  '6863 - KOODO Avalon Mall': '1100040688',
  '6864 - KOODO Regent Mall': '1100040692',
  '6865 - KOODO McAllister Place': '1100040693',
  '6866 - KOODO Champlain Place': '1100040694',
  '6870 - KOODO Quinte Mall': '1100040753',
  '6871 - KOODO Les Rivieres': '1100040755',
  '6872 - KOODO Place du Royaume': '1100040762',
  '6873 - KOODO Place Longueuil': '1100040766',
  '6874 - KOODO La Grande Place des B-F': '1100040771',
  '6877 - KOODO White Oaks Mall': '1100040704',
  '6878 - KOODO Markville SC': '1100040775',
  '6880 - KOODO Lansdowne Place': '1100040901',
  '6882 - KOODO Orchard Park SC': '1100040784',
  '6883 - KOODO Northgate SC': '1100040763',
  "6887 - KOODO Carrefour de L'Estrie": '1100040774',
  '6891 - KOODO Park Place SC': '1100040885',
  '6892 - KOODO Sunnyside Mall': '1100040786',
  '6896 - KOODO Les Gal. de Granby': '1100040778',
  '6898 - KOODO Mic Mac Mall': '1100040788',
  '6900 - KOODO Les Prom. Gatineau': '1100040776',
  '6902 - KOODO Les Gal. Chagnon': '1100040891',
  '6903 - KOODO Cross Iron Mills': '1100040821',
  '6908 - KOODO New Sudbury Centre': '1100041168',
  '6911 - KOODO Les Gal. Joliette': '1100041213',
  '6914 - KOODO Station Mall': '1100041287',
  '6917 - KOODO Place Versailles': '1100041322',
  '6918 - KOODO Lambton Mall': '1100041425',
  '6919 - KOODO Chinook Centre': '1100041544',
  '6921 - KOODO Bowmanville Mall': '1100041343',
  '6924 - KOODO Polo Park SC': '1100041406',
  '6928 - KOODO Southgate Centre': '1100041464',
  '6929 - KOODO Les Prom. Beauport': '1100041483',
  '6931 - KOODO Les Prom. Drummondville': '1100041484',
  '6932 - KOODO Les Gal. St. Hyacinthe': '1100042543',
  '6939 - KOODO Bayshore Shopping Centre': '1100042783',
  '6945 - KOODO Corner Brook Plaza': '1100043874',
  '6952 - KOODO Woodgrove Centre': '1100044249',
  '6953 - KOODO West Edmonton Mall': '1100044242',
  '6955 - KOODO Cottonwood Mall': '1100044241',
  '6956 - KOODO Portage Place': '1100044244',
  '6962 - KOODO The Bay Centre': '1100044586',
  '6966 - KOODO Pacific Centre': '1100045363',
  '6967 - KOODO Willowbrook Mall': '1100045256'
};

export const outletIdStoreCodeMapping = {
  '1100028901': '6421 - TELUS Scarborough Town Centre',
  '1100029401': '6458 - TELUS Montreal Flagship',
  '1100029402': '6443 - TELUS Centre Rockland',
  '1100030041': '6408 - TELUS Carrefour Laval',
  '1100030042': '6478 - TELUS Les Gal. de Terrebonne',
  '1100030043': '6444 - TELUS Carrefour Angrignon',
  '1100030044': '6461 - TELUS Les Rivieres',
  '1100030046': "6439 - TELUS Les Gal. D'Anjou",
  '1100030047': '6462 - TELUS Les Gal. de Hull',
  '1100030049': '6438 - TELUS Les Prom. St. Bruno',
  '1100030050': '6452 - TELUS Place Fleur de Lys',
  '1100030051': '6459 - TELUS Place Ste Foy',
  '1100030052': '6450 - TELUS Place Vertu',
  '1100030056': '6441 - TELUS Fairview Pointe Claire',
  '1100030059': '6445 - TELUS Place Rosemere',
  '1100030060': '6446 - TELUS Place Versailles',
  '1100030062': '6471 - TELUS Yonge Eglinton Ctr',
  '1100030063': '6447 - TELUS Susie Lake',
  '1100030064': '6413 - TELUS Bayshore Shopping Centre',
  '1100030065': '6432 - TELUS Burlington Mall',
  '1100030066': '6435 - TELUS Carlingwood SC',
  '1100030067': '6420 - TELUS Cataraqui Town Centre',
  '1100030068': '6411 - TELUS Champlain Place',
  '1100030069': '6467 - TELUS Conestoga Mall',
  '1100030070': '6470 - TELUS Cornwall Square',
  '1100030071': '6400 - TELUS Devonshire Mall',
  '1100030072': '6426 - TELUS Dufferin Mall',
  '1100030073': '6410 - TELUS Eastgate Square',
  '1100030074': '6407 - TELUS Erin Mills Town Centre',
  '1100030075': '6403 - TELUS Fairview Mall',
  '1100030076': '6401 - TELUS Fairview Park Mall',
  '1100030077': '6409 - TELUS Georgian Mall',
  '1100030078': '6449 - TELUS Halifax Shopping Centre',
  '1100030079': '6425 - TELUS Hillcrest Mall',
  '1100030080': '6414 - TELUS Lansdowne Place',
  '1100030081': '6402 - TELUS Lime Ridge SC',
  '1100030082': '6434 - TELUS Lynden Park Mall',
  '1100030083': '6405 - TELUS Markville SC',
  '1100030084': '6416 - TELUS Masonville Place',
  '1100030085': '6468 - TELUS McAllister Place',
  '1100030086': '6415 - TELUS Mic Mac Mall',
  '1100030087': '6451 - TELUS Montreal Eaton Centre',
  '1100030088': '6464 - TELUS New Sudbury Centre',
  '1100030089': '6477 - TELUS Oakville Place',
  '1100030090': '6423 - TELUS Oshawa Centre',
  '1100030091': '6418 - TELUS Pen Centre',
  '1100030092': '6417 - TELUS Pickering Town Centre',
  '1100030093': "6429 - TELUS Place D'Orleans",
  '1100030095': '6466 - TELUS Quinte Mall',
  '1100030096': '6412 - TELUS Regent Mall',
  '1100030098': '6424 - TELUS Square One',
  '1100030099': '6463 - TELUS St. Laurent Centre',
  '1100030100': '6453 - TELUS St. Vital Centre',
  '1100030101': '6431 - TELUS Stone Road Mall',
  '1100030102': '6433 - TELUS Tecumseh Mall',
  '1100030104': '6406 - TELUS Toronto Eaton Centre',
  '1100030105': '6469 - TELUS Village Shopping Centre',
  '1100030106': '6428 - TELUS Upper Canada Mall',
  '1100030107': '6430 - TELUS White Oaks Mall',
  '1100030109': '6427 - TELUS Yorkdale Shopping Centre',
  '1100030111': '6479 - TELUS First Maple Ctr Chatham',
  '1100030281': '6482 - TELUS Les Gal. Rive Nord',
  '1100030322': '6480 - TELUS Mayflower Mall',
  '1100030323': '6483 - TELUS Carrefour du Nord',
  '1100030324': '6481 - TELUS Avalon Mall',
  '1100030325': '6503 - TELUS Kanata Centrum Walk',
  '1100030326': '6487 - TELUS Cornwall Centre',
  '1100030327': '6485 - TELUS 4202 St. Denis',
  '1100030328': '6488 - TELUS Midtown Plaza',
  '1100030329': '6486 - TELUS Heritage Place',
  '1100030443': '6490 - TELUS Les Prom. Gatineau',
  '1100030445': '6492 - TELUS Corner Brook Plaza',
  '1100030446': '6493 - TELUS Mapleview SC',
  '1100030661': '6500 - TELUS First Railside',
  '1100031141': '6496 - TELUS Westside Market Village',
  '1100031143': '6498 - TELUS Place du Royaume',
  '1100031144': '6501 - TELUS 477 Dundas',
  '1100031542': '6502 - TELUS Centre Alma',
  '1100032401': '6504 - TELUS Huntsville Power Centre',
  '1100032501': '6472 - TELUS Rideau Shopping Centre',
  '1100032741': '6507 - TELUS Sherway Gardens',
  '1100032821': '6509 - TELUS Vaughan Mills',
  '1100032822': '6508 - TELUS Brock/Taunton Power Ctr',
  '1100033163': '6512 - TELUS Main Street Listowel',
  '1100033164': '6513 - TELUS Festival Marketplace',
  '1100033165': '6514 - TELUS Tillsonburg Town Centre',
  '1100033944': '6519 - TELUS Aurora Gateway',
  '1100033981': '6520 - TELUS Southland SC',
  '1100033982': '6521 - TELUS Les Gal. de la Capitale',
  '1100033984': '6523 - TELUS Milton Crossroads',
  '1100033986': '6525 - TELUS Westridge Orillia',
  '1100033990': '6529 - TELUS Alliston Market Village',
  '1100034064': '6530 - TELUS La Plaza de la Mauricie',
  '1100034146': '6533 - TELUS Polo Park Inline',
  '1100034164': '6535 - TELUS Northgate SC',
  '1100034366': '6541 - TELUS Place Laurier',
  '1100034491': '6551 - TELUS Niagara Square',
  '1100034492': "6550 - TELUS Carrefour de L'Estrie",
  '1100034552': '6473 - TELUS Trois Rivieres Ouest',
  '1100034613': '6557 - TELUS RioCan Durham',
  '1100034631': '6559 - TELUS Taunton/Harmony',
  '1100034994': '6562 - TELUS Chapman Mills',
  '1100035015': '6564 - TELUS Lambton Mall',
  '1100035016': '6565 - TELUS 10/30 Lifestyle Centre',
  '1100036037': '6569 - TELUS Heartland Town Centre',
  '1100036200': '6573 - TELUS Bracebridge',
  '1100036202': '6575 - TELUS Bridgeview Plaza',
  '1100036438': '6577 - TELUS Eglinton Square',
  '1100037297': '6580 - TELUS Wheeler Park Power Ctr',
  '1100037299': '6582 - TELUS Carrefour Argenteuil',
  '1100037680': '6586 - TELUS West Bowmanville SC',
  '1100037681': '6587 - TELUS Bramalea City Centre',
  '1100038337': '6801 - KOODO Metropolis at Metrotown',
  '1100038339': '6803 - KOODO Guildford Town Centre',
  '1100038340': '6804 - KOODO Richmond Centre',
  '1100038377': '6806 - KOODO Toronto Eaton Centre',
  '1100038378': '6807 - KOODO Scarborough Town Centre',
  '1100038379': '6808 - KOODO Square One',
  '1100038381': '6812 - KOODO Lime Ridge SC',
  '1100038400': '6815 - KOODO Carrefour Laval',
  '1100038401': '6816 - KOODO Les Prom. St. Bruno',
  '1100038417': '6817 - KOODO Fairview Pointe Claire',
  '1100038418': '6819 - KOODO Carrefour Angrignon',
  '1100038419': "6820 - KOODO Les Gal. D'Anjou",
  '1100038420': '6822 - KOODO Mail Champlain',
  '1100038421': '6821 - KOODO Carrefour du Nord',
  '1100038424': '6818 - KOODO Montreal Eaton Centre',
  '1100038498': '6825 - KOODO Oshawa Centre',
  '1100038564': '6591 - TELUS Dartmouth Crossing',
  '1100038577': '6826 - KOODO Yorkdale Shopping Centre',
  '1100040257': '6592 - TELUS Cambridge Centre',
  '1100040391': '6840 - KOODO Les Gal. de la Capitale',
  '1100040392': '6851 - KOODO Place Laurier',
  '1100040408': '6835 - KOODO Cataraqui Town Centre',
  '1100040409': '6831 - KOODO Bramalea City Centre',
  '1100040459': '6848 - KOODO Stone Road Mall',
  '1100040460': '6850 - KOODO Pen Centre',
  '1100040462': '6836 - KOODO Devonshire Mall',
  '1100040466': '6844 - KOODO Masonville Place',
  '1100040469': '6841 - KOODO Londonderry Mall',
  '1100040470': '6839 - KOODO Kingsway Mall',
  '1100040471': '6842 - KOODO Market Mall',
  '1100040472': '6846 - KOODO Southcentre Mall',
  '1100040474': '6852 - KOODO Sunridge Mall',
  '1100040554': '6593 - TELUS Timmins Square',
  '1100040587': '6858 - KOODO Burlington Mall',
  '1100040680': '6860 - KOODO St. Laurent Centre',
  '1100040683': '6861 - KOODO Lynden Park Mall',
  '1100040685': '6862 - KOODO Halifax Shopping Centre',
  '1100040688': '6863 - KOODO Avalon Mall',
  '1100040691': '6595 - TELUS Carleton Place Colonnade',
  '1100040692': '6864 - KOODO Regent Mall',
  '1100040693': '6865 - KOODO McAllister Place',
  '1100040694': '6866 - KOODO Champlain Place',
  '1100040704': '6877 - KOODO White Oaks Mall',
  '1100040753': '6870 - KOODO Quinte Mall',
  '1100040755': '6871 - KOODO Les Rivieres',
  '1100040762': '6872 - KOODO Place du Royaume',
  '1100040763': '6883 - KOODO Northgate SC',
  '1100040766': '6873 - KOODO Place Longueuil',
  '1100040771': '6874 - KOODO La Grande Place des B-F',
  '1100040774': "6887 - KOODO Carrefour de L'Estrie",
  '1100040775': '6878 - KOODO Markville SC',
  '1100040776': '6900 - KOODO Les Prom. Gatineau',
  '1100040778': '6896 - KOODO Les Gal. de Granby',
  '1100040784': '6882 - KOODO Orchard Park SC',
  '1100040786': '6892 - KOODO Sunnyside Mall',
  '1100040788': '6898 - KOODO Mic Mac Mall',
  '1100040821': '6903 - KOODO Cross Iron Mills',
  '1100040885': '6891 - KOODO Park Place SC',
  '1100040891': '6902 - KOODO Les Gal. Chagnon',
  '1100040901': '6880 - KOODO Lansdowne Place',
  '1100041168': '6908 - KOODO New Sudbury Centre',
  '1100041213': '6911 - KOODO Les Gal. Joliette',
  '1100041287': '6914 - KOODO Station Mall',
  '1100041322': '6917 - KOODO Place Versailles',
  '1100041343': '6921 - KOODO Bowmanville Mall',
  '1100041406': '6924 - KOODO Polo Park SC',
  '1100041425': '6918 - KOODO Lambton Mall',
  '1100041464': '6928 - KOODO Southgate Centre',
  '1100041483': '6929 - KOODO Les Prom. Beauport',
  '1100041484': '6931 - KOODO Les Prom. Drummondville',
  '1100041507': '6601 - TELUS Northgate Mall (SK)',
  '1100041544': '6919 - KOODO Chinook Centre',
  '1100041574': '6602 - TELUS Centre at Circle & 8th',
  '1100041575': '6603 - TELUS Station Mall',
  '1100041814': '6604 - TELUS Lawson Heights',
  '1100041919': '6605 - TELUS Prince Albert',
  '1100042543': '6932 - KOODO Les Gal. St. Hyacinthe',
  '1100042743': '6607 - TELUS Seaway Mall',
  '1100042783': '6939 - KOODO Bayshore Shopping Centre',
  '1100043015': '6622 - TELUS Royal City Centre',
  '1100043016': '6612 - TELUS Central City',
  '1100043017': '6617 - TELUS Kingsway Mall',
  '1100043018': '6610 - TELUS Bonnie Doon SC',
  '1100043019': '6613 - TELUS Country Hills Town Ctr',
  '1100043020': '6609 - TELUS Willowbrook Mall',
  '1100043034': '6620 - TELUS North Hill Centre',
  '1100043035': '6625 - TELUS Sunridge Mall',
  '1100043036': '6614 - TELUS Cross Iron Mills',
  '1100043037': '6623 - TELUS Southgate Centre',
  '1100043038': '6621 - TELUS Northgate Centre (AB)',
  '1100043039': '6624 - TELUS St. Albert Centre',
  '1100043040': '6618 - TELUS Londonderry Mall',
  '1100043042': '6615 - TELUS Edmonton City Centre',
  '1100043045': '6619 - TELUS Mill Woods Town Centre',
  '1100043857': '6640 - TELUS Hillside Centre',
  '1100043858': '6645 - TELUS Metropolis at Metrotown',
  '1100043862': '6634 - TELUS Chinook Centre Flagship',
  '1100043864': '6635 - TELUS Chinook Centre Main',
  '1100043865': '6654 - TELUS Pacific Centre',
  '1100043866': '6642 - TELUS Market Mall',
  '1100043867': '6638 - TELUS Crystal Mall',
  '1100043871': '6641 - TELUS Lougheed Town Centre',
  '1100043872': '6660 - TELUS Shawnessy SC',
  '1100043874': '6945 - KOODO Corner Brook Plaza',
  '1100043876': '6661 - TELUS Shepard Regional Centre',
  '1100043879': '6669 - TELUS Lynn Valley',
  '1100043880': '6665 - TELUS The Core',
  '1100043881': '6655 - TELUS Park Royal SC',
  '1100043882': '6670 - TELUS Westhills',
  '1100043884': '6651 - TELUS West Edmonton Mall Main',
  '1100043886': '6644 - TELUS Mayfair Shopping Centre',
  '1100043887': '6664 - TELUS The Bay Centre',
  '1100043888': '6652 - TELUS West Edmonton Mall',
  '1100043889': '6653 - TELUS Tillicum Mall',
  '1100043891': '6648 - TELUS Woodgrove Centre',
  '1100043892': '6668 - TELUS Lloyd Mall',
  '1100043893': '6650 - TELUS Westshore Town Centre',
  '1100043894': '6656 - TELUS Richmond Centre',
  '1100043896': '6657 - TELUS Scottsdale Centre',
  '1100043897': '6659 - TELUS Seven Oaks',
  '1100043898': '6636 - TELUS Cottonwood Mall',
  '1100043899': '6658 - TELUS Semiahmoo SC',
  '1100043900': '6671 - TELUS Whistler',
  '1100043901': '6639 - TELUS Guildford Town Centre',
  '1100043902': '6631 - TELUS Southcentre Mall',
  '1100043903': '6630 - TELUS Uptown',
  '1100043905': '6667 - TELUS Kitsilano',
  '1100043906': '6666 - TELUS Coquitlam Centre',
  '1100044241': '6955 - KOODO Cottonwood Mall',
  '1100044242': '6953 - KOODO West Edmonton Mall',
  '1100044244': '6956 - KOODO Portage Place',
  '1100044246': '6673 - TELUS Peter Pond SC',
  '1100044247': '6674 - TELUS Pine Centre',
  '1100044249': '6952 - KOODO Woodgrove Centre',
  '1100044586': '6962 - KOODO The Bay Centre',
  '1100045134': '6200 - TELUS Granville',
  '1100045159': '6676 - TELUS Orchard Park SC',
  '1100045237': '6678 - TELUS Intercity SC',
  '1100045256': '6967 - KOODO Willowbrook Mall',
  '1100045345': '6693 - TELUS Capilano Mall',
  '1100045363': '6966 - KOODO Pacific Centre',
  '1100045429': '6688 - TELUS Carrefour Richelieu',
  '1100045430': '6689 - TELUS Les Gal. de Granby',
  '1100045431': '6690 - TELUS Les Gal. St. Hyacinthe',
  '1100045432': '6691 - TELUS Les Prom. Drummondville',
  '1100045496': '6679 - TELUS Collingwood',
  '1100045505': '6680 - TELUS Garden',
  '1100045506': '6681 - TELUS Deerfoot Meadows',
  '1100045507': '6682 - TELUS Beacon Hill',
  '1100045508': '6683 - TELUS Marlborough Mall',
  '1100045703': '6684 - TELUS 34th Avenue',
  '1100046410': '6686 - TELUS Lindsay Square',
  '1100046427': '6687 - TELUS Robson Street',
  '1100047997': '6701 - TELUS Trinity Common',
  '1100048255': '6702 - TELUS Tsawwassen Mills',
  '1100048484': '6717 - TELUS Polo Park Kiosk',
  '1100048488': '6721 - TELUS Portage Place',
  '1100048741': '6723 - TELUS Park Place SC',
  '1100048813': '6707 - TELUS The Path',
  '1100048816': '6724 - TELUS The Boardwalk',
  '1100048819': '6722 - TELUS Park Place (ON)',
  '1100050723': '6727 - TELUS - Metropolis Flagship',
  '1100052655': '6731 - TELUS Les Galeries Lac St Jean'
};
